import { FormsModel } from "../../../types/generated/models";
import { useGetQuery } from "../../../hooks/useClientPortalQuery";

export interface IUseFormsHook {
    data?: FormsModel | null;
    isLoading: boolean;
}

export function useForms(guidKey: string): IUseFormsHook {
    const { data, isLoading } = useGetQuery<FormsModel>({ url: `/api/v1.0/${guidKey}/CustomForm/GetForms` });

    return {
        data: data,
        isLoading,
    };
}
